import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { exponentialRetryDelay } from '@/lib/react-query/exponentialRetryDelay';
import { prescreenEndpoints } from '@/modules/prescreen/constants';
import { isTransientInviteError } from '@/modules/prescreen/inviteError';

import { prescreenQueryKeys } from './queryKeys';

const MAX_INVITE_RETRIES = 3;

export const usePrescreenInviteQuery = (slug: string) => {
  return useQuery({
    queryKey: prescreenQueryKeys.invite(slug),
    queryFn: async () => {
      const { data } = await fetchClient.GET(prescreenEndpoints.intro, {
        params: { path: { slug } },
      });
      return data;
    },
    enabled: !!slug,
    retry: (failureCount, error) =>
      failureCount < MAX_INVITE_RETRIES && isTransientInviteError(error),
    retryDelay: (attemptIndex) => exponentialRetryDelay(attemptIndex, 5000),
    staleTime: Infinity,
  });
};
